import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { LogoutService } from '../services/logout.service';

/**
 * Turns the logout URL into an action: the navigation to it is cancelled, so the current
 * page stays on show while LogoutService ends the session and moves on to the login form.
 */
export const LogoutGuard: CanActivateFn = (): boolean => {
  void inject(LogoutService).logout();
  return false;
};
